import { connect } from 'react-redux';

import {
  getIsHotelOnly,
  getIsMobile,
  getIsWhitelabel,
} from 'src/store/view/selectors';
import { addCouponAction, addBonusAction } from '../../../store/actions/order';

// Selectors:
import { getClientBonusScore } from '../../../../../store/client/selectors';

import {
  getOrderCoupon,
  getIsOrderPrebuildFetching,
  getRemainingPaymentAmount,
  makeGetOrderFieldError,
  getOrderDiscountType,
  getOrderDiscountPrice,
  getDiscountMethods,
  getPackageFullPrice,
} from '../../../store/selectors/order';

// Hocs:
import Discount from './Discount';

const getCouponOrderFieldError = makeGetOrderFieldError('coupon');
const getBaseOrderFieldError = makeGetOrderFieldError('base');

const mapStateToProps = (state) => ({
  discountMethods: getDiscountMethods(state),
  isFetching: getIsOrderPrebuildFetching(state),
  bonusScore: getClientBonusScore(state),
  coupon: getOrderCoupon(state),
  errors: {
    couponErrors: getCouponOrderFieldError(state),
    baseErrors: getBaseOrderFieldError(state),
  },
  appliedType: getOrderDiscountType(state),
  discountPrice: getOrderDiscountPrice(state),
  priceWithDiscount: getRemainingPaymentAmount(state),
  fullPrice: getPackageFullPrice(state),
  isHotelOnly: getIsHotelOnly(state),
  isWhitelabel: getIsWhitelabel(state),
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = (dispatch) => ({
  addCoupon: (coupon) => dispatch(addCouponAction(coupon)),
  addBonus: (bonus) => dispatch(addBonusAction(bonus)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Discount);
